document.addEventListener('DOMContentLoaded', function() {
  // Select all tab wrappers
  const wrappers = document.querySelectorAll('.p-tabs-wrapper');

  wrappers.forEach(wrapper => {
    const tabs = wrapper.querySelectorAll('.p-tab');
    const contents = wrapper.querySelectorAll('.p-tab-content');

    tabs.forEach(tab => {
      tab.addEventListener('click', function() {
        const tabId = this.dataset.tab;
        console.log('test')
        // Remove active states only inside this wrapper
        tabs.forEach(t => t.classList.remove('active'));
        contents.forEach(c => c.classList.remove('active'));

        // Add active to clicked tab and its content
        this.classList.add('active');
        const content = wrapper.querySelector(`.p-tab-content[data-tab="${tabId}"]`);
        if (content) content.classList.add('active');
      });
    });
  });
});


document.addEventListener("DOMContentLoaded", function() {
    const selectEl = document.getElementById("variantSelect");
    const priceEl = document.getElementById("variant-price");
    const imageEl = document.getElementById("variant-image");
    const titleEl = document.getElementById("variant-title");
    const variantIdInput = document.getElementById("variant-id");

    selectEl.addEventListener("change", function () {
        const selected = this.options[this.selectedIndex];

        priceEl.innerText = selected.getAttribute("data-price");

        if (selected.getAttribute("data-image")) {
            imageEl.src = selected.getAttribute("data-image");
        }

        variantIdInput.value = selected.value;
    });
});
